import template from './compensationChangeModal.html';
import controller from './compensationChangeModal.controller';

let CompensationChangeModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'lg',
  windowClass: "hmodal-info animated zoomIn"
};

export default CompensationChangeModalComponent;



// WEBPACK FOOTER //
// ./client/common/modals/compensationChangeModal/compensationChangeModal.component.js